import { render, staticRenderFns } from "./generic-table.vue?vue&type=template&id=3c2f2230&scoped=true"
import script from "./generic-table.vue?vue&type=script&lang=ts"
export * from "./generic-table.vue?vue&type=script&lang=ts"
import style0 from "./generic-table.vue?vue&type=style&index=0&id=3c2f2230&prod&lang=scss&scoped=true"
import style1 from "./generic-table.vue?vue&type=style&index=1&id=3c2f2230&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f2230",
  null
  
)

export default component.exports